<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { mdiShieldAlertOutline } from '@mdi/js';

/**
 * What the page shows when Keycloak cannot be reached at all.
 *
 * Mounted instead of the app, because without a session there is nothing the
 * app could show. A blank page is the alternative, and a blank page tells an
 * operator nothing about whether to wait, reload or phone someone.
 */
const { t } = useI18n();
const reload = () => window.location.reload();
</script>

<template>
  <v-app>
    <v-main>
      <v-empty-state
        :icon="mdiShieldAlertOutline"
        :headline="t('auth.unreachableTitle')"
        :text="t('auth.unreachableText')"
      >
        <template #actions>
          <v-btn variant="flat" color="primary" @click="reload">{{ t('auth.retry') }}</v-btn>
        </template>
      </v-empty-state>
    </v-main>
  </v-app>
</template>
